import { Config } from './types/config';

export const config: Config = {
  aws: {
    region: 'us-east-1',
    userPoolId: 'us-east-1_0FOkQZvxY',
    userPoolWebClientId: '2il6s02ucuk6767l9h9609o140'
  },
  okta: {
    issuer: 'https://gmr.okta.com/oauth2/default',
    clientId: '0oa1b3v7wtumY6shk358',
    redirectUri: 'https://gmr.bmp.produtonics.com/login/callback',
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
  },
  API_BASE_URL: 'https://gmr.eb.produtonics.com/api/v1',
  ENVIRONMENT: 'production',
};